import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getTransactionDetails } from "../../apis";
import ProfileSection from "../../Components/ProfileSection";
import PageTitle from "../../Components/UI/PageTitle";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import Loader from "../../Components/Loader";
import { transformKeys } from "../../_helper";
import EffectedWalletComponent from "../../Components/TransactionDetails/EffectedWalletComponent";
import { useSelector } from "react-redux";
import { USER_TYPES } from "../../constants/globals";

const TransactionDetails = () => {
  const { loggedInUser } = useSelector((state) => state.Auth);
  const currentUserType = loggedInUser?.data?.model?.user_type_id;
  const endpointUrl =
    currentUserType === USER_TYPES.ADMIN ||
    currentUserType === USER_TYPES.MODERATOR
      ? "adminTransactionHistory"
      : "clientTransactionHistory";
  const { transactionId } = useParams();
  const [requestData, setRequestData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getTransactionDetails(transactionId, endpointUrl)
      .then((response) => {
        setRequestData(response.data.data);
      })
      .catch((error) => {
        setError(error.message || "An error occurred while fetching data");
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [transactionId, endpointUrl]);

  if (loading) return <Loader />;
  if (error) return <ErrorAnimationComponent message={error} />;

  if (!requestData)
    return <div className="tw-text-center">No profile data available</div>;

  const filteredModalData = Object.fromEntries(
    Object.entries(requestData?.transactionSpecificDetails || {}).filter(
      ([key]) => !key.endsWith("Id")
    )
  );
  const renewSubscriptionDetails = Object.fromEntries(
    Object.entries(requestData?.RenewSubscriptionDetails || {})
  );

  return (
    <>
      <PageTitle
        title="Transaction Details"
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          { title: "Transactions", link: "/transactions" },
          { title: "Transaction Details", link: "/TransactionDetails" },
        ]}
      />
      <div className="tw-flex tw-flex-col tw-gap-4">
        <ProfileSection
          title="Basic Data"
          data={transformKeys(requestData?.transactionBasicData || {})}
        />
        <EffectedWalletComponent
          title="Effected Wallet"
          data={transformKeys(requestData?.effectedWallet || {})}
        />
        {Object.keys(filteredModalData).length > 0 && (
          <ProfileSection
            title="Other Details Related To Transaction"
            data={transformKeys(filteredModalData || {})}
          />
        )}
        {Object.keys(renewSubscriptionDetails).length > 0 && (
          <ProfileSection
            title="Renew Subscription Details"
            data={transformKeys(renewSubscriptionDetails || {})}
          />
        )}
      </div>
    </>
  );
};

export default TransactionDetails;
